import { Note } from "./components/note/notes";
import * as fs from "fs";
import * as $ from "jquery";
import * as moment from 'moment';
import * as ko from "knockout";
import '../node_modules/jwt-decode/build/jwt-decode.min.js';
import { Utils } from "./utils";
import { User, UserData, UserDataWrapper } from "./UserData";
import { TreeType, TreeDto } from './components/tree/tree';
import { StrategyDto } from './components/strategy/strategy';
import { Filter } from "./components/case/caseentryoverview";

export class ReturnWrapper<T> {
    Type: string
    Payload: T

    constructor(type: string, payload: T) {
        this.Type = type;
        this.Payload = payload;
    }
}

$.ajaxSetup({
    xhrFields: {
        withCredentials: true
    },
    crossDomain: true
});


export class Routing {
    name: string
    params: any

    constructor(name: string, params: any) {
        this.name = name;
        this.params = params;
    }
}


export class RNSAPI {
    public static config = JSON.parse(fs.readFileSync(__dirname + "/../renocloudURL.json", "utf8"));
    public static origin = RNSAPI.config.renocloud;
    public static base = RNSAPI.origin + "/api"

    public static User: KnockoutObservable<User | undefined> = ko.observable(undefined)
    private static UserData: UserData = null;

    public static async receiveUserData() {
        if (!RNSAPI.UserData) {
            let data = (await RNSAPI.getUserData()).Payload;
            if (data.Value) {
                RNSAPI.UserData = (JSON.parse(data.Value));
            } else {
                RNSAPI.UserData = new UserData("foobar");
            }

            return RNSAPI.UserData;
        }
    };

    public static async writeUserData(data: UserData) {
        RNSAPI.UserData = data;
        RNSAPI.setUserData(data);
    }

    public static CurrentRouting: KnockoutObservable<Routing> = ko.observable();

    public static Token = "";

    public static mapTypeToScope = {
        "mandant": "2",
        "gegner": "3",
        "bank": "4",
        "versicherung": "5",
        "behörde": "6",
        "anwalt": "7",
        "gericht": "8",
        "sonstige": "9"
    };
    private static rpcRequest(url: string, data: string): Promise<ReturnWrapper<any>> {
        return new Promise<ReturnWrapper<void>>(function (resolve, reject) {
            $.ajax(`${RNSAPI.base}${url}`, {
                data: data,
                contentType: 'application/json',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('access_token', RNSAPI.Token);
                },
                type: "POST",
            }).done(resolve).fail(reject);
        });
    }

    public static login(token: string) {
        RNSAPI.Token = token;
        let decoded = (window as any).jwt_decode(RNSAPI.Token);
        RNSAPI.User(new User(decoded.ShortHandSymbol, decoded.Role));
        Utils.createCookie("jwt", RNSAPI.Token, 365);
    }

    public static getAppointments(start: Date, end: Date): Promise<ReturnWrapper<any>> {
        let startString = start.toISOString();
        let endString = end.toISOString();
        let data = JSON.stringify({
            UserId: RNSAPI.User() ? RNSAPI.User().username : "GR",
            StartDate: startString,
            EndDate: endString
        });
        return RNSAPI.rpcRequest("/Appointments/Search", data);
    }

    public static getAppointmentsForCase(caseId: string, start: Date, end: Date): Promise<ReturnWrapper<any>> {
        let startString = start.toISOString();
        let endString = end.toISOString();
        let data = JSON.stringify({
            CaseID: caseId,
            StartDate: startString,
            EndDate: endString
        });
        return RNSAPI.rpcRequest("/Appointments/ForCase", data);
    }

    public static getAppointment = (Id: string) => RNSAPI.rpcRequest("/Appointments/Get", JSON.stringify({ Id: Id }));
    public static createAppointment = (appointment: any) => RNSAPI.rpcRequest("/Appointments/Create", ko.toJSON(appointment));
    public static updateAppointment = (appointment: any) => RNSAPI.rpcRequest("/Appointments/edit", ko.toJSON(appointment));
    public static deleteAppointment = (Id: string) => RNSAPI.rpcRequest("/Appointments/Delete", JSON.stringify({ Id: Id }));
    public static completeAppointment = (Id: string) => RNSAPI.rpcRequest("/Appointments/Complete", JSON.stringify({ Id: Id }));

    public static getDeadlines = (day: moment.Moment) => RNSAPI.rpcRequest("/Deadlines/WorkableOn", JSON.stringify({ Date: day.format("YYYY-MM-DD") }));
    public static getDeadlinesForCase = (id: string) => RNSAPI.rpcRequest("/Deadlines/ForCase", JSON.stringify({ CaseId: id }));
    public static getDeadlineReasons = () => RNSAPI.rpcRequest("/Deadlines/GetReasons", JSON.stringify({}));
    public static createDeadline = (deadline: any) => RNSAPI.rpcRequest("/Deadlines/Create", JSON.stringify(deadline));
    public static calcDeadline = (obj: any) => RNSAPI.rpcRequest("/Deadlines/CalcDeadline", JSON.stringify(obj));
    public static completeDeadline = (deadline: any) => RNSAPI.rpcRequest("/Deadlines/Complete", JSON.stringify(deadline));
    public static extendDeadline = (oldDeadline: any, newDeadlineDate: string) => {
        let obj = {
            OldDeadLine: oldDeadline,
            NewDeadLineDate: newDeadlineDate
        };

        return RNSAPI.rpcRequest("/Deadlines/Extend", JSON.stringify(obj));
    }

    public static delegateDeadline = (oldDeadline: any, clerkId: string) => {
        let obj = {
            DeadLine: oldDeadline,
            NewUser: clerkId
        };

        return RNSAPI.rpcRequest("/Deadlines/Delegate", JSON.stringify(obj));
    }

    public static uploadTextHeader = (base64Content: string) => {
        let obj = {
            HeaderData: base64Content
        }
        return RNSAPI.rpcRequest("/Texts/UploadHeader", JSON.stringify(obj));
    };
    public static uploadToScanPool = (fileName: string, base64Content: string) => {
        let obj = {
            FileName: fileName,
            FileData: base64Content
        }
        return RNSAPI.rpcRequest("/ScanPool/Upload", JSON.stringify(obj));
    };
    public static getScanPoolByDateInterval = (startDate: moment.Moment, endDate: moment.Moment) => {
        let obj = {
            StartDate: startDate.toISOString(),
            EndDate: endDate.toISOString()
        };
        return RNSAPI.rpcRequest("/ScanPool/SearchAll", JSON.stringify(obj));
    }
    public static getScanPoolEntryByName = (fileName: string) => RNSAPI.rpcRequest("/ScanPool/Get", JSON.stringify({ FileName: fileName }));

    public static getZPE = () => RNSAPI.rpcRequest("/Zpe/Get", JSON.stringify({}));
    public static getMailsByDateInterval = (startDate: moment.Moment, endDate: moment.Moment) => {
        let obj = {
            StartDate: startDate.toISOString(),
            StopDate: endDate.toISOString()
        };
        return RNSAPI.rpcRequest("/Zpe/GetMailRange", JSON.stringify(obj));
    };
    public static getMailById = (accountId: string, mailId: string) => {
        let obj = {
            AccountId: accountId,
            RnsMailID: mailId
        };
        return RNSAPI.rpcRequest("/Zpe/GetMailContent", JSON.stringify(obj));
    }
    public static getMailByECase = (id: string) => RNSAPI.rpcRequest("/Documents/GetMailByRecordID", JSON.stringify({ ECaseRecordId: id }));
    public static sendMail = (mail: any) => RNSAPI.rpcRequest("/Zpe/SendMail", JSON.stringify(mail));
    public static createInbox = (inbox: any) => RNSAPI.rpcRequest("/Zpe/CreateInbox", ko.toJSON(inbox));
    public static updateInbox = (inbox: any) => RNSAPI.rpcRequest("/Zpe/UpdateInbox", ko.toJSON(inbox));
    public static getAllInboxes = () => RNSAPI.rpcRequest("/ZPE/GetAllAccounts", JSON.stringify({}));
    public static getInboxById = (id: string) => RNSAPI.rpcRequest("/ZPE/GetAccount", JSON.stringify({ AccountId: id }));
    public static deleteInboxById = (id: string) => RNSAPI.rpcRequest("/ZPE/DeleteAccount", JSON.stringify({ AccountId: id }));
    //public static deleteMailById = (AccountId: string, EmailID: string) => RNSAPI.rpcRequest("/ZPE/DeleteMail", JSON.stringify({ AccountID: AccountId, RnsMailID: EmailID }));

    public static deleteMailbyId = (accountId: string, mailId: string) => {
        let input = {
            AccountId: accountId,
            RnsMailID: mailId
        };
        return RNSAPI.rpcRequest("/ZPE/DeleteMail", JSON.stringify(input));
    }

    public static getResubmissions = () => RNSAPI.rpcRequest("/Resubmissions/GetAll", JSON.stringify({}));
    public static getResubmissionsByRange = (range: any) => RNSAPI.rpcRequest("/Resubmissions/ByRange", JSON.stringify(range));
    public static getResubmission = (id: string) => RNSAPI.rpcRequest("/Resubmissions/Get", JSON.stringify({ Id: id }));
    public static getResubmissionByCaseId = (id: string) => RNSAPI.rpcRequest("/Resubmissions/GetByCaseId", JSON.stringify({ CaseId: id }));
    public static getResubmissionReasons = () => RNSAPI.rpcRequest("/Resubmissions/GetReasons", JSON.stringify({}));
    public static createResubmission = (resubmission: any) => RNSAPI.rpcRequest("/Resubmissions/Create", ko.toJSON(resubmission));
    public static updateResubmission = (resubmission: any) => RNSAPI.rpcRequest("/Resubmissions/Edit", ko.toJSON(resubmission));
    public static deleteResubmission = (ID: string) => RNSAPI.rpcRequest("/Resubmissions/Delete", JSON.stringify({ ID: ID }));
    public static completeResubmission = (ID: string) => RNSAPI.rpcRequest("/Resubmissions/Complete", JSON.stringify({ ID: ID }));

    public static suggestCaseId = () => RNSAPI.rpcRequest("/Cases/SuggestId", JSON.stringify({}));
    public static updateCaseIdSuggestion = (recordId: string) => RNSAPI.rpcRequest("/Cases/UpdateSuggestion", JSON.stringify({ ID: recordId }));

    public static getSachbearbeiter = () => RNSAPI.rpcRequest("/Clerks/Get", JSON.stringify({}));

    public static getReferate = () => RNSAPI.rpcRequest("/Units/Get", JSON.stringify({}));
    //public static addReferat = (newUnit: any) => RNSAPI.rpcRequest("/Units/Add", ko.toJSON(newUnit));
    
    public static addReferat = (pId: string, pName: string) => {
        let data = JSON.stringify({
            Id: pId,
            Name: pName
        });
        return RNSAPI.rpcRequest("/Units/Add", data);
    }

    public static getRechtsformen = () => RNSAPI.rpcRequest("/LegalForms/Get", JSON.stringify({}));

    public static getCases = () => RNSAPI.rpcRequest("/Cases/Search", JSON.stringify({ query: "" }));
    public static getCaseByCaseId = (caseId: string) => RNSAPI.rpcRequest("/Cases/GetCase", JSON.stringify({ Id: caseId }));
    public static createCase = (newCase: any) => RNSAPI.rpcRequest("/Cases/Create", ko.toJSON(newCase));

    public static getLastCases = (amount: any) => RNSAPI.rpcRequest("/Cases/LastCases", JSON.stringify({ "Amount": amount }));

 
    public static updateCase = (newCase: any) => RNSAPI.rpcRequest("/Cases/Update", ko.toJSON(newCase));

    public static getCaseEntry = (id: string) => RNSAPI.rpcRequest("/ECases/ForId", JSON.stringify({ RecordId: id }));
    public static getCaseEntriesForId = (caseId: string) => RNSAPI.rpcRequest("/ECases/ForCase", JSON.stringify({ CaseId: caseId }));
    public static getCaseEntriesForWorkFlow = (workflow: string) => RNSAPI.rpcRequest("/ECases/ForWorkflowMark", JSON.stringify({ WorkflowMark: workflow }));
    public static getCaseEntriesForFilter = (filter: Filter): any => RNSAPI.rpcRequest("/ECases/ForFilter", JSON.stringify(filter));
    public static createCaseEntry = (entry: any) => RNSAPI.rpcRequest("/ECases/Insert", ko.toJSON(entry));
    public static updateCaseEntryDocument = (id: string, document: string) => RNSAPI.rpcRequest("/ECases/Update", JSON.stringify({ ECaseId: id, DocumentData: document }));
    public static updateCaseEntry = (entry: any) => RNSAPI.rpcRequest("/ECases/Set", ko.toJSON(entry));
    public static setCaseEntryWorkflowMark = (recordId: string, mark: string) => RNSAPI.rpcRequest("/ECases/SetWorkFlowMark", ko.toJSON({ RecordId: recordId, WorkFlowMark: mark }));

    public static getAllTagTypes = () => RNSAPI.rpcRequest("/Tags/GetAll", JSON.stringify({}));
    public static deleteTagType = (name: string) => RNSAPI.rpcRequest("/Tags/Delete", JSON.stringify({ Name: name }));
    public static getTagTypeByName = (name: string) => RNSAPI.rpcRequest("/Tags/Get", JSON.stringify({ Name: name }));
    public static createTagType = (tagType: any) => RNSAPI.rpcRequest("/Tags/Add", ko.toJSON(tagType));
    public static updateTagType = (tagType: any) => RNSAPI.rpcRequest("/Tags/Update", ko.toJSON(tagType));
    public static getTagsForECaseRecordId = (id: string) => RNSAPI.rpcRequest("/Tags/GetForRecord", ko.toJSON({ Name: id }));
    public static setTagsForECaseRecordId = (tags: Array<string>, id: string) => RNSAPI.rpcRequest("/Tags/SetTags", ko.toJSON({ DatUhr: id, TagNames: tags }));

    public static getAllViews = () => RNSAPI.rpcRequest("/Views/GetAll", JSON.stringify({}));
    public static getViewByName = (name: string) => RNSAPI.rpcRequest("/Views/Get", JSON.stringify({ Name: name }));
    public static deleteView = (name: string) => RNSAPI.rpcRequest("/Views/Delete", JSON.stringify({ Name: name }));
    public static createView = (view: any) => RNSAPI.rpcRequest("/Views/Add", ko.toJSON(view));
    public static updateView = (view: any) => RNSAPI.rpcRequest("/Views/Update", ko.toJSON(view));

    public static rvgGetAll = (version: string) => RNSAPI.rpcRequest("/rvg/getall", JSON.stringify({ Version: version }));
    public static rvgSearch = (searchObject: any) => RNSAPI.rpcRequest("/rvg/search", JSON.stringify(searchObject));
    public static rvgCalculate = (calculateObject: any) => RNSAPI.rpcRequest("/rvg/calculate", JSON.stringify(calculateObject));
    public static rvgAddEntry = (caseid: any, entryObject: any) => RNSAPI.rpcRequest("/rvg/entry", JSON.stringify({ CaseID: caseid, Test: entryObject }));
    public static rvgLoadEntries = (caseid: string) => RNSAPI.rpcRequest("/rvg/loadentries", JSON.stringify({ CaseID: caseid }));
    public static rvgAbgleich = () => RNSAPI.rpcRequest("/rvg/abgleich", JSON.stringify({}));


    public static generateCaseEntryText = (CaseId: string, TemplateName: string, AddressType: string, AddressKeyword: string, WorkflowMark: string, DictationMark: string) => {
        let scopes = {
            "mandant": "01",
            "gegner": "02",
            "sonstige": "03"
        };

        let data = {
            CaseId: CaseId,
            TemplateName: TemplateName,
            AddressType: scopes[AddressType],
            AddressKeyword: AddressKeyword,
            WorkflowMark: WorkflowMark,
            DictationMark: DictationMark
        }

        return RNSAPI.rpcRequest("/Texts/generate", JSON.stringify(data));
    }

    public static getDocumentData = (eCaseId: string) => RNSAPI.rpcRequest("/Documents/Get", JSON.stringify({ ECaseRecordId: eCaseId }));
    public static deleteRecord = (eCaseId: string) => RNSAPI.rpcRequest("/ECases/Delete", JSON.stringify({ RecordId: eCaseId }));

    public static getTemplates = () => RNSAPI.rpcRequest("/Texts/GetTemplates", JSON.stringify({}));

    public static createPerson = (person: any, handler: string) => RNSAPI.rpcRequest(`/Addresses/Add${handler}`, ko.toJSON(person));
    public static updatePerson = (person: any, type: string) => RNSAPI.rpcRequest(`/Addresses/Update${type}`, ko.toJSON(person));

    public static deletePerson(keyword: string, type: string): Promise<ReturnWrapper<any>> {
        let scope = RNSAPI.mapTypeToScope[type.toLowerCase()];
        return RNSAPI.rpcRequest(`/Addresses/Delete`, JSON.stringify({ PersonKeyword: keyword, Scope: scope }));
    }

    public static joinPerson(personKeyword: string, caseId: string, handler: string): Promise<ReturnWrapper<any>> {
        let data = JSON.stringify({
            CaseId: caseId,
            PersonKeyword: personKeyword,
            Scope: RNSAPI.mapTypeToScope[handler.toLowerCase()]
        });
        return RNSAPI.rpcRequest(`/Addresses/Join`, data);
    }

    public static unjoinPerson(personKeyword: string, caseId: string, handler: string): Promise<ReturnWrapper<void>> {
        let data = JSON.stringify({
            CaseId: caseId,
            PersonKeyword: personKeyword,
            Scope: RNSAPI.mapTypeToScope[handler.toLowerCase()]
        });
        return RNSAPI.rpcRequest(`/Addresses/Unjoin`, data);
    }

    public static getPersonForKeyword(keyword: string, type: string): Promise<ReturnWrapper<any>> {
        let data = JSON.stringify({
            Scope: RNSAPI.mapTypeToScope[type.toLowerCase()],
            SearchValue: keyword
        });
        return RNSAPI.rpcRequest("/Addresses/ExactSearch", data);
    }

    public static getPersonsForCaseId = (caseId: string) => RNSAPI.rpcRequest("/Addresses/Search", JSON.stringify({ scope: 'bycaseid', searchValue: caseId }))

    public static getPersonsForScope(type: string): Promise<ReturnWrapper<any>> {
        let data = JSON.stringify({
            Scope: RNSAPI.mapTypeToScope[type.toLowerCase()],
            SearchValue: ""
        });
        return RNSAPI.rpcRequest("/Addresses/Search", data);
    }

    public static checkCollision = (lastName: string) => RNSAPI.rpcRequest("/Addresses/CheckCollision", JSON.stringify({ searchValue: lastName }))

    public static getTableDump = (dbNumber: number) => RNSAPI.rpcRequest("/Debug/DbTableDump", JSON.stringify({ DbNumber: dbNumber }))

    public static getNotes = () => RNSAPI.rpcRequest("/UserNote/Get", JSON.stringify({}));
    public static getNote = (id: string) => RNSAPI.rpcRequest("/UserNote/GetNote", JSON.stringify({ ID: id }));
    public static createNote = (note: Note) => RNSAPI.rpcRequest("/UserNote/Add", JSON.stringify(note));
    public static updateNote = (note: Note) => RNSAPI.rpcRequest("/UserNote/Update", JSON.stringify(note));
    public static deleteNote = (id: string) => RNSAPI.rpcRequest("/UserNote/Delete", JSON.stringify({ ID: id }));

    public static markDictationAsDone = (recordId: string) => RNSAPI.rpcRequest("/ECases/markDictationAsDone", JSON.stringify({ RecordId: recordId }));
    public static addDictate = (dto: any) => RNSAPI.rpcRequest("/Dictates/AddDictate", JSON.stringify(dto));
    public static updateDictate = (dto: any) => RNSAPI.rpcRequest("/Dictates/UpdateDictate", JSON.stringify(dto));
    public static getDictateById = (id: string) => RNSAPI.rpcRequest("/Dictates/GetDictate", JSON.stringify({ ID: id }));
    public static getAudioById = (id: string) => RNSAPI.rpcRequest("/Dictates/GetAudio", JSON.stringify({ ID: id }));


    public static moveMailToCase = (AccountID: string, RnsMailID: string, CaseId: string, ClerkId: string) => {
        let obj = {
            AccountID: AccountID,
            RnsMailID: RnsMailID,
            CaseId: CaseId,
            ClerkId: ClerkId
        }
        return RNSAPI.rpcRequest("/Zpe/MoveMailToCase", JSON.stringify(obj));
    }
    public static moveScanToCase = (FileName: string, CaseId: string, ClerkId: string) => {
        let obj = {
            FileName: FileName,
            CaseId: CaseId,
            ClerkId: ClerkId
        }
        return RNSAPI.rpcRequest("/ScanPool/MoveScanToCase", JSON.stringify(obj));
    }

    public static deleteStampById = (stampId: string) => RNSAPI.rpcRequest("/Stamps/DeleteStamp", JSON.stringify({ ID: stampId }));
    public static getStampsByECaseId = (recordId: string) => RNSAPI.rpcRequest("/Stamps/GetStamps", JSON.stringify({ ID: recordId }));
    public static addStamp = (stampText: string, stampType: string, recordId: string) => {
        let obj = {
            Text: stampText,
            Type: stampType,
            DatUhr: recordId
        };
        return RNSAPI.rpcRequest("/Stamps/AddStamp", JSON.stringify(obj));
    }
    public static getStampTemplates = () => RNSAPI.rpcRequest("/Stamps/GetTemplates", JSON.stringify({}));

    public static addOrUpdateTree = (dto: TreeDto) => RNSAPI.rpcRequest("/Taxonomie/AddOrUpdateTree", ko.toJSON(dto));
    public static getTreesByType = (type: TreeType) => RNSAPI.rpcRequest("/Taxonomie/GetTreesByType", JSON.stringify({ "Type": type }));
    public static getTreeByTypeAndId = (type: TreeType, id: string) => RNSAPI.rpcRequest("/Taxonomie/GetTree", JSON.stringify({ "Type": type, TreeId: id }));
    public static deleteTreeByTypeAndId = (type: TreeType, id: string) => RNSAPI.rpcRequest("/Taxonomie/DeleteTree", JSON.stringify({ "Type": type, TreeId: id }));
    public static getStrategies = () => RNSAPI.rpcRequest("/Taxonomie/GetStrategies", JSON.stringify({}));
    public static getTaxonomies = () => RNSAPI.rpcRequest("/Taxonomie/GetTaxonomies", JSON.stringify({}));
    public static getTaxonomieById = (id: string) => RNSAPI.rpcRequest("/Taxonomie/GetTaxonomie", JSON.stringify({ ID: id }));
    public static addTaxonomie = (taxon: any) => RNSAPI.rpcRequest("/Taxonomie/AddTaxon", ko.toJSON(taxon));
    public static updateTaxonomie = (taxon: any) => RNSAPI.rpcRequest("/Taxonomie/UpdateTaxon", ko.toJSON(taxon));
    public static deleteTaxonomieById = (id: string) => RNSAPI.rpcRequest("/Taxonomie/DeleteTaxon", JSON.stringify({ ID: id }));
    public static joinTaxonomie = (strategy: StrategyDto) => RNSAPI.rpcRequest("/Taxonomie/JoinTaxonomie", ko.toJSON(strategy));
    public static unjoinTaxonomie = (id: string) => RNSAPI.rpcRequest("/Taxonomie/UnJoinTaxonomie", JSON.stringify({ StrategyId: id }));

    public static createExtendedCase = (eCase: any) => RNSAPI.rpcRequest("/ExtendedData/CreateCase", ko.toJSON(eCase));
    public static getExtendedCase = (eCase: string) => RNSAPI.rpcRequest("/ExtendedData/GetCase", JSON.stringify({ "id": eCase }));
    public static saveExtendedCase = (eCase: any) => RNSAPI.rpcRequest("/ExtendedData/UpdateCase", ko.toJSON(eCase));


    public static createHistoryEntry = (registernummer: any, aktion: any) => RNSAPI.rpcRequest("/History/AddEntry", JSON.stringify({ "Case": registernummer, "Aktion": aktion }));

    public static getLawFirmUsers = () => RNSAPI.rpcRequest("/LawFirm/GetUsers", JSON.stringify({}));
    public static createLawFirmUser = (entryObject: any) => RNSAPI.rpcRequest("/LawFirm/CreateUser", ko.toJSON(entryObject));
    public static getLawFirmUser = (user: any) => RNSAPI.rpcRequest("/LawFirm/GetUser", JSON.stringify({ "Benutzer": user }));
    public static updateLawFirmUser = (entryObject: any) => RNSAPI.rpcRequest("/LawFirm/UpdateUser", ko.toJSON(entryObject));

    //This data is not hold in a FATS database on the server
    //Later when there is SQL support all data should be migrated to SQL
    private static getUserData = () => RNSAPI.rpcRequest("/UserData/get", "") as Promise<ReturnWrapper<UserDataWrapper>>;
    private static setUserData = (data: UserData) => RNSAPI.rpcRequest("/UserData/set", JSON.stringify(new UserDataWrapper(data)));

   
}

if (!localStorage["notes"]) localStorage["notes"] = JSON.stringify([]);
if (!localStorage["deadlines"]) localStorage["deadlines"] = JSON.stringify([]);
